import { Fragment } from "react";
import { useServerSdk } from "../RootNavigator/services/ServerSdk";
import UsersView from "./UsersView";
import OrganizationsView from "./OrganizationsView";
import ProgramsView from "./ProgramsView";
import TagsScreen from "./TagsScreen";
import useData from "@hpo/client/utilities/useData";
import Await from "@hpo/client/utilities/Await";
import ContentLayout from "@hpo/client/components/layout/ContentLayout";
import Tabs, { Tab } from "@hpo/client/utilities/Tabs";

export default function UsersAndBeneficiaryScreen() {
  const server = useServerSdk();
  const [users, usersData] = useData(async () => server.getUsers(), []);
  const organizations = server.suspender.use(server.getOrganizations());

  const reload = () => {
    usersData.reloadSilent();
    server.suspender.refresh(server.getOrganizations());
  };

  return (
    <Fragment>
      <Await promise={users} hideReload>
        {(users) => (
          <ContentLayout title="Gestion de la plateforme">
            <Tabs showSingleTab>
              <Tab id="users" title="Utilisateurs">
                <UsersView
                  users={users}
                  organizations={organizations}
                  onReload={reload}
                />
              </Tab>
              <Tab id="organizations" title="Bénéficiaires">
                <OrganizationsView
                  organizations={organizations}
                  onReload={reload}
                />
              </Tab>
              <Tab id="programs" title="Appels à projet">
                <ProgramsView />
              </Tab>
              <Tab id="tags" title="Etiquettes d'indicateurs">
                <TagsScreen />
              </Tab>
            </Tabs>
          </ContentLayout>
        )}
      </Await>
    </Fragment>
  );
}
